export enum MailTemplates {
  CreateAccount = 'MailTemplateCreateAccount',
  ResetPassword = 'MailTemplateResetPassword'
}
